var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPracticalLearningStudents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.217,
    height: 150.002,
    viewBox: "0 0 135.217 150.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.217,
    height: 150.002,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.146,85.253c-1.1-14.58-15.47-27.95-29.27-44.96C91.956,23.383,78.587,2.843,62.457.3c-16.02-2.66-34.691,12.59-46.511,29.6C4.127,46.8-.953,65.473.146,82.933a74.884,74.884,0,0,0,20.44,46.29c11.93,12.48,28.171,21.1,44.19,20.77,15.911-.45,31.6-9.73,45.4-22.21,13.92-12.37,26.081-28.06,24.97-42.53M77.4,88.333a11,11,0,1,1,11-11,10.994,10.994,0,0,1-11,11",
    fill: "#0af"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M41.017,73.463h16.71V71.5H41.017Zm0,6.88h16.71v-1.97H41.017ZM99,47.913H96.046v-2.95a1.965,1.965,0,0,0-1.96-1.97H68.537a1.973,1.973,0,0,0-1.391.58l-2.54,2.54-2.55-2.54a1.925,1.925,0,0,0-1.38-.58H35.116a1.972,1.972,0,0,0-1.96,1.97v2.95H30.207a1.965,1.965,0,0,0-1.97,1.96v49.14a1.967,1.967,0,0,0,1.97,1.97H92.626L88.7,97.053H32.166V51.843h.99V94.1a1.964,1.964,0,0,0,1.96,1.96h36.16a19.429,19.429,0,0,1-6.87-3.93H37.086v-45.2h22.77l3.76,3.93v12.52a19.751,19.751,0,0,1,1.97-1.68V50.863l3.76-3.93h22.77v17.5a19.515,19.515,0,0,1,3.93,6.86V51.843h.991v36.87l3.93,3.93V49.873A1.966,1.966,0,0,0,99,47.913M77.376,64.623a12.775,12.775,0,1,0,12.78,12.77,12.786,12.786,0,0,0-12.78-12.77m.02,23.71a11,11,0,1,1,11-11,10.994,10.994,0,0,1-11,11m-36.379-1.11h16.71v-1.97H41.017Zm0-28.5h4.91v-7.86h-4.91Zm0,7.86h16.71v-1.96H41.017ZM47.9,59.7h9.83v-1.96H47.9Zm0-6.88h9.83v-1.96H47.9Zm23.581,0h16.71v-1.96H71.477Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.076,86.933a16.794,16.794,0,1,0-4.169,4.16l15.9,15.9,4.17-4.16Zm-13.68,1.4a11,11,0,1,1,11-11,10.994,10.994,0,0,1-11,11",
    fill: "#02e2ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticalLearningStudents);
export default __webpack_public_path__ + "static/media/practical_learning_students.1a8ec9af2bc297d9514827c5175216aa.svg";
export { ForwardRef as ReactComponent };